import React from "react";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { AddCustomColumnModalBase } from "./modules/AddCustomColumnModalBase/AddCustomColumnModalBase";
import { useNotifications } from "utils/hooks";
import { formatErrorMessage } from "schedule-v2/components/recorded-content/ExamCreation/modals/QuestionsModal/questionsModal.utils";
import { toSnakeCase } from "features/Common/modules/DataTypes/utils/strings";
import { OLDER_CONTACT_VALUE_OPTIONS } from "../CustomColumnFormFields/constants/CustomColumnFormField.constants";
import { useCreateCustomColumn } from "../CustomColumn/apis/createCustomColumn";

export const AddCustomColumnModal = ({ sectionName }) => {
  const { notify } = useNotifications();
  const createCustomColumn = useCreateCustomColumn({ sectionName });

  const handleAddCustomColumn = (values) => {
    const {
      column_name,
      field_type,
      options,
      default_value,
      custom_value,
      older_contacts,
      sections,
    } = values;

    const columnData = {
      column_name,
      column_slug: toSnakeCase(column_name),
      data_type: field_type,
      default_column_value: default_value,
      section_names: sections,
      metadata: {
        options: options?.map((i) => i.option),
        older_contacts_value:
          older_contacts == OLDER_CONTACT_VALUE_OPTIONS.CUSTOM.value
            ? custom_value
            : OLDER_CONTACT_VALUE_OPTIONS.DEFAULT.value
            ? default_value
            : null,
        older_contacts_selection: older_contacts,
      },
    };

    createCustomColumn.mutate(columnData);
  };

  return (
    <Form
      initialValues={{}}
      onSubmit={handleAddCustomColumn}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({ handleSubmit, invalid, errors, values }) => {
        const handleFormSubmit = () => {
          if (invalid)
            formatErrorMessage(errors).forEach((error) =>
              notify(error, "error")
            );
          handleSubmit(values);
        };
        return (
          <form onSubmit={handleFormSubmit}>
            <AddCustomColumnModalBase
              handleSubmit={handleFormSubmit}
              submitting={createCustomColumn.isLoading}
            />
          </form>
        );
      }}
    </Form>
  );
};
